import Pubnub from "pubnub";

export const pubnubApp: Pubnub = new Pubnub({
  publishKey: import.meta.env.VITE_PUBNUB_PUBLISH_KEY,
  subscribeKey: import.meta.env.VITE_PUBNUB_SUBSCRIBE_KEY,
  uuid: "WebApp",
});
